import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import * as APIRoutes from 'modules/app/API'
import * as App from 'modules/app/App'
import API from 'fw/system/API';
import CorporateOwnersStaff from './CorporateOwnersStaff'
import CorporateOwnersStaffPopUp from './CorporateOwnersStaffPopUp'
import { CommentsGrid } from 'areas/shared/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel'
import * as Notifications from 'fw/globals/Notifications'
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import { ActionButton } from 'fw/components';
import * as ReportManager from 'modules/reports/ReportManager';
import ReviewType from 'areas/shared/consts/ReviewType';

class CorporateOwners extends SetupTab {
    initialForm() {
        return {
            reviewComment: ''
        }
    }

    urls() {
        return {
            get: APIRoutes.Admin.url('/siteReview/getCorporateOwners'),
            save: APIRoutes.Admin.url('/siteReview/saveCorporateOwners'),
            loadComments: APIRoutes.Admin.url("/appReview/getComments")
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId
        }
    }

    saveRequest() {
        var form = this.state.form;

        return {
            entityId: form.certificationId,
            corporateOwners: form.corporateOwners,
            rowVersion: form.rowVersion,
            reviewStatus: form.reviewStatus,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    afterSave() {
        this.loadComments();
        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });
    }

    loadComments = () => {
        let rq = {
            certificationId: this.state.form.certificationId,
            queueTypeCode: ReviewType.SITE_REVIEW.code,
        };

        new API().get(this.urls().loadComments, rq,
            {
                success: (r) => {
                    let form = this.state.form;
                    form.comments = r.data.comments;
                    form.canCompleteReview = r.data.canCompleteReview;

                    this.setState(form);
                }
            });
    }

    updatePostData = (form, dirty) => {
        this.validateReviewStatus(form);
        this.setState({ form })

        if (dirty === true)
            this.dirt();
    }

    validateReviewStatus = (form) => {
        let canComplete = !form.hasOwnerUpdatedFlag;

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    ready = () => {
        // If slected form is paper -> Redirect to FinalRecomm
        if (this.state.form.isPaperForm)
            window.location.href = `/admin/siteReview/${this.props.selectedId}/finalRecomm/${this.props.queueTypeCode}`;
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form.reviewStatus = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    addCorporateOwner = (order) => {
        this.setState({
            showCorporateOwnerPopUp: true,
            currentCorporateOwner: this.newCorporateOwner(order)
        })
    }

    onCorporateOwnerClose = () => {
        this.setState({
            showCorporateOwnerPopUp: false
        })
    }

    onCorporateOwnerEdit = (index) => {
        this.setState({
            showCorporateOwnerPopUp: true,
            currentCorporateOwner: this.state.form.corporateOwners[index]
        })
    }

    onCorporateOwnerRemove = (index) => {
        let form = this.state.form

        form.corporateOwners.splice(index, 1)

        this.updatePostData(form, true)
    }

    onCorporateOwnerChange = (corporateOwner) => {
        let form = this.state.form

        var index = form.corporateOwners.findIndex(function (element) {
            return element.veteranOwnerId === corporateOwner.veteranOwnerId
        })

        if (index >= 0)
            form.corporateOwners[index] = corporateOwner
        else
            form.corporateOwners = form.corporateOwners.concat(corporateOwner)

        if (corporateOwner.veteranOwnerId > 0)
            Notifications.success('The Corporate Owner has been updated.')
        else
            Notifications.success('The Corporate Owner has been added.')

        this.updatePostData(form, true)
    }

    componentWillMount() {
        this.setState({
            showCorporateOwnerPopUp: false,
            currentCorporateOwner: this.newCorporateOwner()
        })
    }

    newCorporateOwner = (order) => {
        return {
            veteranOwnerId: -(Date.now() | 0),
            order: order,
            firstName: '',
            lastName: '',
            title: '',
            email: '',
            veteran: order === 0,
            present: false,
            id: false,
            fromSiteReview: true,
            phones: []
        };
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewCorporateOwnersReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'COW'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                queueTypeCode={'STR'}
                                reviewTypeCode={'COW'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        var form = this.state.form;

        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3>
                            {this.state.form.siteReviewTitle}
                            {this.renderAdminStepToolbar()}
                            <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <CorporateOwnersStaffPopUp
                            visible={this.state.showCorporateOwnerPopUp}
                            onClose={this.onCorporateOwnerClose}
                            onSave={this.onCorporateOwnerChange}
                            currentCorporateOwner={this.state.currentCorporateOwner} />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <CorporateOwnersStaff
                            disabled={!this.state.enabled}
                            corporateOwners={form.corporateOwners}
                            onEdit={this.onCorporateOwnerEdit}
                            onRemove={this.onCorporateOwnerRemove} />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <br />
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={form.comments}
                        documents={form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"COW"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={form.siteReviewSiteInfoId}
                        readonly={!this.state.privileges.edit || !this.state.enabled}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange}
                    />
                </Row>
                {this.state.form.showComplete ?
                    <Row>
                        <ReviewPanel stepName="Corporate Owners"
                            key={form.reviewStatus}
                            onChange={this.handleReviewStatus}
                            reviewStatus={form.reviewStatus}
                            canComplete={!form.hasOwnerUpdatedFlag} />
                    </Row>
                    : null}

            </React.Fragment>
        )
    }
}

export default CorporateOwners;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/corporateOwners/CorporateOwners.js